export const MODALS = {
  filterModal: "filterModal",
  phonePickerModal: "phonePickerModal",
  shopsModal: "shopsModal",
  tcoModal: "tcoModal"
};
